<div class="not-found-container">
  <div class="logo-container">
    <img src="./assets/images/logo/Dashboardly-logo.svg" alt="Logo" class="logo" />
  </div>

  <div class="error-content">
    <div class="error-image">
      <img src="./assets/svgIcon/404-red.svg" alt="404 Error" class="error-img" />
    </div>

    <h1 class="error-title">Sorry, Something Goes Wrong</h1>

    <p class="error-message">
      The page you are attempting to reach is currently not available. This may be because the page does not exist or
      has been moved.
    </p>

    <button class="btn btn-primary" [routerLink]="'/dashboard'">Back to homepage</button>
  </div>
</div>
